import React from 'react';
import './contactButton.css';

export const ContactButton = ({ label, onClick }: ContactButtonProps) => {
  return (
    <button
      className={'fr-btn fr-btn--secondary fr-btn--sm fr-icon-mail-line fr-btn--icon-left contact-button uppercase'}
      onClick={onClick}>
      <span>{label ?? 'contact'}</span>
    </button>
  );
};

interface ContactButtonProps {
  label?: string;
  onClick: () => void;
}
